export type UserItem = {
	avatr: string;
	name: string;
	school: string;
	desc: string;
};

/**
 * 国家文案配置
 */
export const TEACHER_COUNTRY_CONIFG: Record<string, UserItem[]> = {
	'en-US': [
		{
			avatr: 'https://web-data.zmlearn.com/image/hKAuz2b61VP1mLbZUuG6gH/avator1.png',
			name: 'Sophie',
			school: 'Harvard University',
			desc: `<p>Subject: English, Maths</p><p>Grade: Grade 7-Grade 10</p><p>Completed lessons: 2561</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/hsW7YRPGPpgpMXpouXYVcS/avator2.png',
			name: 'Hannah',
			school: 'Yale University',
			desc: `<p>Subject: English, Maths</p><p>Grade: Grade 9-Grade 12</p><p>Completed lessons: 1092 </p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/aggjtMMyP9tNTosWgXSemd/avator3.png',
			name: 'Brian',
			school: 'Columbia University',
			desc: `<p>Subject: Biology, Physics</p><p>Grade: Grade 7-Grade 8</p><p>Completed lessons: 1270</p>`,
		},
	],
	'en-CA': [
		{
			avatr: 'https://web-data.zmlearn.com/image/raJtdVnZNNsdKG92vXAghx/s2%402x.png',
			name: 'Nicholas',
			school: 'University of Toronto',
			desc: `<p>Subject: English</p><p>Grade: Grade 1- Grade 6</p><p>Completed lessons: 1761</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/29HhVEDUiEVhfXZmiKYokS/s1%402x.png',
			name: 'Annebelle',
			school: 'Mcgill University',
			desc: `<p>Subject: Maths</p><p>Grade: Grade 10-Grade 12</p><p>Completed lessons: 1372 </p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/iet7tSej9tU9VJpntugVV4/s3%402x.png',
			name: 'Omar',
			school: 'University of Montreal',
			desc: `<p>Subject: English, Maths</p><p>Grade: Grade 7-Grade 9</p><p>Completed lessons: 1194</p>`,
		},
	],
	'en-AU': [
		{
			avatr: 'https://web-data.zmlearn.com/image/tvMgERHDzavE3eZLjTmGDd/teacher1%402x.png',
			name: 'Sarah',
			school: 'University of Melbourne',
			desc: `<p>Subject: English, Maths</p><p>Grade: Grade 7-Grade 10</p><p>Completed lessons: 1931</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/nWHNuvmUUTUtDyY1s46cmB/teacher2%402x.png',
			name: 'Oscar',
			school: 'University of Sydney',
			desc: `<p>Subject: Maths</p><p>Grade: Grade 11-Grade 12</p><p>Completed lessons: 1783</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/nUPQk4x3DbuLr4HaajtcqV/teacher3%402x.png',
			name: 'Omar',
			school: 'University of Queensland',
			desc: `<p>Subject: English, Maths</p><p>Grade: Grade 1-Grade 6</p><p>Completed lessons: 1514</p>`,
		},
	],
	'en-GB': [
		{
			avatr: 'https://web-data.zmlearn.com/image/gfTmFhvtLQC7SrwqiXXs5v/tch1%402x.png',
			name: 'Cindy',
			school: 'University of Cambridge',
			desc: `<p>Subject: English, Maths</p><p>Grade: Y7-Y11</p><p>Completed lessons: 2561</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/oPGKyvs38vWCCd15XKbR43/tch2%402x.png',
			name: 'Jacob',
			school: 'University of Oxford',
			desc: `<p>Subject: Biology, Physics</p><p>Grade: Y12-Y13</p><p>Completed lessons: 1270</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/tQPwD1Yi9MGen3oEETabv8/tch3%402x.png',
			name: 'Annie',
			school: 'Imperial College London',
			desc: `<p>Subject: English, Maths</p><p>Grade: Y1-Y6</p><p>Completed lessons: 1092</p>`,
		},
	],
	'en-IE': [
		{
			avatr: 'https://web-data.zmlearn.com/image/3aRiTUpX7v5BFyxcab947k/teacher1%402x.png',
			name: 'Lauren Galvin',
			school: 'Maynooth University',
			desc: `<p>Subject: Maths</p><p>Grade: 5th Year-6th Year</p><p>Completed lessons: 1817</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/e9rr6FW511iU3JKXXKCaEc/teacher2%402x.png',
			name: 'Victoria Rn',
			school: 'University College Cork',
			desc: `<p>Subject: English</p><p>Grade: 6th Year</p><p>Completed lessons: 1547</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/rnG56enUy6isGTaFGLnyss/teacher3%402x.png',
			name: 'Paul Kavanagh',
			school: 'University of Dublin',
			desc: `<p>Subject: English, Maths</p><p>Grade: 5th Year</p><p>Completed lessons: 1105</p>`,
		},
	],
	'en-NZ': [
		{
			avatr: 'https://web-data.zmlearn.com/image/fpwmjJiZt7ixQUsM1r1hts/teacher1%402x.png',
			name: 'Mattisa',
			school: 'University of Auckland',
			desc: `<p>Subject: English, Maths</p><p>Grade: Y7-Y8</p><p>Completed lessons: 1934</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/MffkCFDeg5oELCFoKFgaf/teacher2%402x.png',
			name: 'Olivia',
			school: 'University of Massey',
			desc: `<p>Subject: Maths</p><p>Grade: Y9-Y13</p><p>Completed lessons: 1354</p>`,
		},
		{
			avatr: 'https://web-data.zmlearn.com/image/8kg7X5aKSAr8TBwB482dGL/teacher3%402x.png',
			name: 'Rhianna',
			school: 'University of Canterbury',
			desc: `<p>Subject: English</p><p>Grade: Y1-Y6</p><p>Completed lessons: 1103</p>`,
		},
	],
};
